<div class="sidebar-detail">
  <div class="sidebar-panel">
    <div class="sidebar-content">
      <div class="detail-section">
        <div class="detail-row">
          <div class="field-label">Prepared by</div>
          <div class="field-value">{{ initiatedBy || 'N/A' }}</div>
        </div>

        @if (resolvedBy) {
          <div class="detail-row">
            <div class="field-label">Resolved by</div>
            <div class="field-value">{{ resolvedBy }}</div>
          </div>
        }

        <div class="detail-row">
          <div class="field-label">Request Date</div>
          <div class="field-value">{{ formatDateStandard(preparedDate) }}</div>
        </div>

        @if (resolvedAt) {
          <div class="detail-row">
            <div class="field-label">Resolution Date</div>
            <div class="field-value">{{ formatDateStandard(resolvedAt) }}</div>
          </div>
        }

        @if (resolution) {
          <div class="detail-row">
            <div class="field-label">Resolution</div>
            <app-state-badge [status]="resolution"></app-state-badge>
          </div>
        }

        @if (detail) {
          <div class="risk-details">
            <div class="detail-row">
              <div class="field-label">Risk Assessment Provider</div>
              <div class="field-value">{{ getRiskProviderName(detail.riskAssessmentProvider) }}</div>
            </div>
            @if (detail.relatedTransactionId) {
              <div class="detail-row">
                <div class="field-label">Transaction ID</div>
                <div class="field-value copyable-value">
                  <span class="olv-hash" [matTooltip]="detail.relatedTransactionId" matTooltipPosition="above">
                    {{ shortenAddress(detail.relatedTransactionId) }}
                  </span>
                  <span [matTooltip]="idTooltipText" matTooltipPosition="above" #idTooltip="matTooltip">
                    <img
                      src="shared-assets/icons/copy.svg"
                      class="copy-icon"
                      (click)="copyToClipboard(detail.relatedTransactionId, idTooltip)"
                      alt="Copy icon"
                      />
                  </span>
                </div>
                <div class="risk-level-update">
                  <h5 class="update-title">Risk Level Update</h5>
                  <div class="risk-comparison">
                    <div class="risk-level">
                      <span class="level-label">Previous:</span>
                      <app-state-badge type="risk" [value]="riskLevelToString(detail.previousRiskLevel)" />
                    </div>
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                    <div class="risk-level">
                      <span class="level-label">Current:</span>
                      <app-state-badge type="risk" [value]="riskLevelToString(detail.currentRiskLevel)" />
                    </div>
                  </div>
                </div>
                @if (detail.reportUrl) {
                  <div class="detail-row">
                    <div class="field-label">Report</div>
                    <div class="field-value clickable" (click)="openReport()">
                      <mat-icon class="icon">open_in_new</mat-icon>
                      View Report
                    </div>
                  </div>
                }
                <!-- Disable Wallet Action -->
                @if (canDisableWallet()) {
                  <div class="detail-row">
                    <div class="field-label">Actions</div>
                    <div class="field-value">
                      <app-button
                        buttonVariant="material-warn"
                        buttonType="button"
                        [state]="processingButtonState"
                        (buttonClick)="disableWallet()"
                        >
                        <mat-icon>block</mat-icon>
                        Disable Wallet
                      </app-button>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        @if (isHistory) {
          <ng-container *ngTemplateOutlet="commentBlock"></ng-container>
        }
        @if (errorMessage) {
          <div class="error-message" role="alert">
            <mat-icon class="error-icon">error</mat-icon>
            {{ errorMessage }}
          </div>
        }
      </div>
      <div class="sidebar-actions">
        @if (!isHistory) {
          <div class="button-group">
            <ng-container *ngTemplateOutlet="commentBlock"></ng-container>

            @if (isAcknowledgeOnly) {
              <app-button
                buttonVariant="primary"
                buttonType="button"
                [state]="processingButtonState"
                *appHasPermission="{ resource: transactionResource, scope: Scopes.Acknowledge }"
                (buttonClick)="onAcknowledge()"
                >
                {{ isProcessing ? 'Processing...' : 'Acknowledge' }}
              </app-button>
            } @else {
              <app-button
                buttonVariant="primary"
                buttonType="button"
                [state]="processingButtonState"
                (buttonClick)="onApprove()"
                >
                {{ isProcessing ? 'Processing...' : 'Approve' }}
              </app-button>
              <app-button
                buttonVariant="sidebar-danger"
                buttonType="button"
                [state]="processingButtonState"
                (buttonClick)="onReject()"
                >
                {{ isProcessing ? 'Processing...' : 'Reject' }}
              </app-button>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <ng-template #commentBlock>
    <div class="comments-heading">Comments</div>
    <textarea
      class="comment-box"
      aria-label="Comments"
      [(ngModel)]="commentText"
      placeholder="Enter your comment"
      [disabled]="isHistory || isProcessing"
    ></textarea>
  </ng-template>
</div>
